(function () {
  app.controller("OverviewCtrl", [
    "$scope",
    "$timeout",
    function ($scope, $timeout) {
      $scope.init = function () {
        //initializing angular controller
      };

      $scope.showOrderDetailsPopup = function (order_number, user_id) {
        let params = {
          order_number: order_number,
          user_id: user_id,
        };
        $.get(`/booking/get_order_details`, params, function (rs) {});
      };

      $scope.add_more_addons_pre_booking = function (order_number) {
        document.getElementById('order_number_field').value = order_number;
        document.getElementById('add_more_addons_form').submit();    
      }


      $scope.onReady = function() {
        if ($scope.require_credit_card) {
          $.get($scope.change_credit_card_user_path, function (rs) {});
        }
        if ($scope.require_emergency_contact) {
          $.get($scope.change_emergency_contacts_user_path, function (rs) {});
        }
        if ($scope.has_organization) {
          $.get($scope.change_organization_user_path, function (rs) {});
        }
      };
    },
  ]);
}.call(this));
